import styled, { css } from 'styled-components';

const TRANS_BG_WHITE_COLOR_THEME = css`
  background: transparent;

  .white-logo {
    visibility: visible;
    opacity: 1;
    @media (max-width: 1199px) {
      visibility: hidden;
      opacity: 0;
    }
  }
  .tertiary-logo {
    visibility: hidden;
    opacity: 0;
    @media (max-width: 1199px) {
      visibility: visible;
      opacity: 1;
    }
  }
  .icon-down-caret {
    fill: var(--white);
  }
  .desktop-right-menu a,
  .menu-item--parent-link,
  .menu-item--parent-link a,
  .menu-item--parent-link i {
    color: var(--white);

    &:hover {
      color: var(--white);
    }

    @media (max-width: 1199px) {
      color: var(--darkest) !important;
    }
  }

  .website-header--announcement-bar {
    border-bottom: none;
  }

  .website-header--main-menu {
    background: transparent;
  }

  &.scrolled {
    .white-logo {
      visibility: hidden;
      opacity: 0;
    }
    .tertiary-logo {
      visibility: visible;
      opacity: 1;
    }

    .menu-item--parent-link,
    .menu-item--parent-link a,
    .menu-item--parent-link i {
      color: var(--darkest);

      &:hover {
        color: var(--darkest);
      }
      .icon-down-caret {
        fill: var(--darkest);
      }
    }

    .website-header--announcement-bar {
      border-bottom: 1px solid var(--grey-3);

      p {
        color: var(--darkest) !important;

        .announcement-bar--link {
          color: var(--darkest) !important;
        }
      }

      .divider {
        background: var(--darkest);
      }

      .announcement-bar-right {
        a {
          color: var(--darkest) !important;
        }

        .announcement-bar--icon {
          color: #17191c;
        }
      }
    }
  }
`;

const TRANS_BG_BLACK_COLOR_THEME = css`
  background: transparent;

  .desktop-right-menu {
    a {
      color: var(--darkest) !important;
    }
  }
  .desktop-menu-items {
    p:not(.notification-message) {
      color: var(--darkest) !important;

      &:hover {
        color: var(--darkest) !important;
      }
    }

    button {
      svg {
        color: var(--darkest) !important;
      }
    }
  }

  .white-logo {
    visibility: hidden;
    opacity: 0;
  }
  .tertiary-logo {
    visibility: visible;
    opacity: 1;
  }
  .website-header--announcement-bar {
    border-bottom: none;
  }

  &.scrolled {
    .website-header--announcement-bar {
      border-bottom: 1px solid var(--grey-3);
    }
  }
`;

const WHITE_BG_BLACK_COLOR_THEME = css`
  background: var(--white);
  ${TRANS_BG_BLACK_COLOR_THEME}

  .website-header--announcement-bar {
    border-bottom: 1px solid var(--grey-3);
  }
`;

const mobileMenuStyles = css`
  position: fixed !important;
  height: 100% !important;
  overflow: auto;
  background: var(--white);
  z-index: var(--z-website-header) !important;
`;

const mobileTransparentNavStyles = css`
  box-shadow: none;

  .mobile-header {
    background: transparent !important;
    border-bottom: none;
  }
  .mobile-header-phone a {
    color: var(--white) !important;
  }
  .website-header--main-menu {
    background: transparent !important;
  }
  .menu-item--parent-link a {
    color: var(--white) !important;
  }
  .icon-down-caret {
    fill: var(--white);
  }
  .white-logo {
    visibility: visible !important;
    opacity: 1 !important;
  }
  .tertiary-logo {
    visibility: hidden !important;
    opacity: 0 !important;
  }
  .mobile-menu--icon span {
    background: var(--white) !important;
    &:before,
    &:after {
      background-color: var(--white) !important;
    }
  }
  &.mobile-menu-opened {
    .white-logo {
      visibility: hidden !important;
      opacity: 0 !important;
    }
    .tertiary-logo {
      visibility: visible !important;
      opacity: 1 !important;
    }
    .menu-item--parent-link a {
      color: var(--darkest) !important;
    }
    .mobile-header {
      background: var(--white) !important;
    }
  }
  &.scrolled {
    background: var(--white) !important;
    .menu-item--parent-link a {
      color: var(--darkest) !important;
      .icon-down-caret {
        fill: var(--darkest);
      }
    }
    .white-logo {
      visibility: hidden !important;
      opacity: 0 !important;
    }
    .tertiary-logo {
      visibility: visible !important;
      opacity: 1 !important;
    }
    .mobile-menu--icon span {
      background: var(--darkest) !important;
      &:before,
      &:after {
        background-color: var(--darkest) !important;
      }
    }
    .mobile-header {
      background: var(--white) !important;
    }
  }
  .website-header--inner-container {
    background: transparent !important;
  }
`;

const WebsiteHeaderContainer = styled.div`
  ${({ theme }) =>
    theme === 'WHITE_BG_BLACK_COLOR'
      ? WHITE_BG_BLACK_COLOR_THEME
      : theme === 'TRANS_BG_BLACK_COLOR'
      ? TRANS_BG_BLACK_COLOR_THEME
      : TRANS_BG_WHITE_COLOR_THEME};

  z-index: var(--z-website-header);
  width: 100%;
  transition: background 0.5s ease;

  .website-header--main-menu {
    background: ${({ background }) => background};
    max-height: fit-content;
    transition: all 0.3s ease;
  }

  .white-logo {
    transition: all 0.2s ease;
  }
  .tertiary-logo {
    transition: all 0.2s ease;
  }
  .menu-item--parent-link,
  .menu-item--parent-link a,
  .menu-item--parent-link i {
    transition: all 0.2s ease;
  }
  a.website-header--button-cta {
    color: white !important;
    transition: all 0.2s ease;
  }

  &.scrolled .website-header--inner-container a.website-header--button-cta {
    color: white !important;
  }

  @media (max-width: 1199px) {
    box-shadow: rgb(0 0 0 / 10%) 0px 0px 8px;
    ${({ mobileMenuOpen }) => mobileMenuOpen && mobileMenuStyles};
    ${({ mobileTransparentNav }) => mobileTransparentNav && mobileTransparentNavStyles}
    transition: none;

    .website-header--main-menu {
      padding: 0 !important;
      background: var(--white);
      z-index: 999999;
      position: relative;
    }

    .website-header--button-cta {
      &.header-cta--transparentWhiteBorder {
        border: 1px solid var(--white);
        color: var(--white);
      }
    }

    .mobile-menu--burger-icon {
      fill: var(--white);
    }

    &.scrolled {
      .mobile-menu--burger-icon {
        fill: var(--black) !important;
      }
    }

    &.scrolled.home,
    &.mobile-menu-opened {
      .header-cta--transparentWhiteBorder {
        background: var(--critical-3);
        border: none;
        color: white;

        &:hover {
          background: var(--critical-4);
        }
      }
    }

    &.subnav {
      .website-header--main-menu .website-header--inner-container {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.shrink-nav {
      .website-header--main-menu .website-header--inner-container {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
    }

    .mobile-menu--burger-icon {
      fill: var(--black);
    }

    &.mobile-transparent {
      .mobile-menu--burger-icon {
        fill: var(--white);
      }
    }
  }

  @media (min-width: 1200px) {
    &.top {
      position: fixed;
      z-index: var(--z-website-header);
    }

    &.scrolled.home {
      .header-cta--transparentWhiteBorder {
        background: var(--critical-3);
        border: none;
        color: white;

        &:hover {
          background: var(--critical-4);
        }
      }
    }

    &.scrolled {
      position: fixed;
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
      z-index: var(--z-website-header);

      .website-header--main-menu {
        background: var(--white);
      }
    }

    &.hide-announcement-bar {
      .website-header--announcement-bar {
        margin-top: ${({ announcementBarHeight }) => `-${announcementBarHeight}px`};
        border: none;
      }
    }

    &.shrink-nav {
      .website-header--main-menu .website-header--inner-container {
        padding: 0 20px !important;
      }
    }
  }
`;

const WebsiteHeaderInnerContainer = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  transition: padding 0.3s ease 0s;

  .website-header--menu-item {
    display: inline-block;
    vertical-align: middle;
    padding: 0 17px;

    button {
      font-size: var(--font-size-16);
      line-height: var(--line-height-110);
      transition: none;
      color: black;
    }
  }

  .mobile-header {
    align-items: center;
    background: white;
    display: flex;
    height: 80px;
    justify-content: space-between;
    left: 0;
    position: relative;
    top: 0;
    width: 100vw;
    z-index: var(--z-website-header);
  }

  .mobile-dropdown {
    position: fixed;
    left: 0;
  }

  .st-menu-splitter {
    display: inline-block;
    height: 27.5px;
    width: 1px;
    border-left: 1px solid #b8d3df;
    vertical-align: middle;
  }

  @media (max-width: 1199px) {
    background: var(--white);
  }

  @media (max-width: 390px) {
    height: 80px;
  }
`;

export { WebsiteHeaderContainer, WebsiteHeaderInnerContainer };
